// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/order_item_requests/salvar
 *
 * Creates or updates a customer request for an order item.
 * - Create: so_oir_id is null
 * - Update: so_oir_id is provided
 */
import { registerContract } from './validate'

export interface Order_item_requests_SalvarInput {
so_oir_order_item_id: number
so_oir_description: string
so_oir_id?: number
so_oir_photo?: string
so_oir_display_order?: number
}

registerContract('Order_item_requests_SalvarInput', {
  so_oir_order_item_id: { type: 'number',  required: true },
  so_oir_description:   { type: 'string',  required: true },
  so_oir_id:            { type: 'number',  required: false },
  so_oir_photo:         { type: 'string',  required: false },
  so_oir_display_order: { type: 'number',  required: false },
})
